import { Palette } from '@mui/material';

export const tooltipOverrides = (palette: Palette) => ({
	tooltip: {
		backgroundColor: palette.tertiary.main,
		color: '#FFFFFF',
		borderRadius: 8,
		boxShadow: palette.mode === 'light'
			? '0 0 5px 0 rgba(74, 74, 74, 0.3), 0 30px 40px 0 rgba(74, 74, 74, 0.3)'
			: 'none',
		padding: 18,
		maxWidth: 350,
		fontSize: 12
	},
	arrow: {
		color: palette.tertiary.main
	}
});

